/* eslint-disable */
import React, { useState, useEffect, useRef, Dispatch, SetStateAction } from 'react'
import { getLanguageCodeFromLS, useTranslation } from '@noahswap/localization'
import { useMatchBreakpoints } from '@noahswap/uikit'
import { formatNumber, formatPrice } from 'utils/formatInfoNumbers'
import Io from '@noahswap/socket'
import CFClient from 'socket/cfws'
// import Io from 'socket/index2.js';
import Tv from '@noahswap/tradeView'

export type LineChartProps = {
  data: any[]
  kLoading?: boolean
  poolData?: any
  setValue?: Dispatch<SetStateAction<number | undefined>> // used for value on hover
  setLabel?: Dispatch<SetStateAction<string | undefined>> // used for value label on hover
} & React.HTMLAttributes<HTMLDivElement>

const TVChartContainerComponent = ({
  data,
  setValue,
  setLabel,
  poolData,
  kLoading = false,
  ...rest
}: LineChartProps) => {
  const { t } = useTranslation() // language code
  const codeFromStorage = getLanguageCodeFromLS() // current language code
  // console.log('当前缓存的语言', codeFromStorage)

  // console.log('data传值', data)
  // console.log('poolData传值', poolData)
  let currentLanguage
  if (codeFromStorage === 'zh-TW') {
    currentLanguage = 'zh_TW'
  }
  if (codeFromStorage === 'en-US') {
    currentLanguage = 'en'
  }
  if (codeFromStorage === 'zh-CN') {
    currentLanguage = 'zh_TW'
  }
  if (codeFromStorage === 'ko-KR') {
    currentLanguage = 'en'
  }
  const chartContainerRef = useRef(null)
  const [lang, setLang] = useState(currentLanguage)
  const { isDesktop } = useMatchBreakpoints()
  const isMobile = isDesktop === false
  const [loading, setLoading] = useState(true)
  const [theme, setTheme] = useState('')
  const [tradName, setTradName] = useState('')
  const [ticker, setTicker] = useState('')
  const [symTrad, setSymTrad] = useState(null)
  const [interval, setInterval] = useState('60')
  // const [pairId, setPairId] = useState('0xf00a9f9c3e986d42429cc79c1baf5dacdffbc9a2');
  const [forwhat, setForwhat] = useState('kline')
  const [poolInfo, setPoolInfo] = useState({})
  const tvChartContainerRef = useRef(null)

  useEffect(() => {
    if (poolData.address) {
      // console.log('池子id', poolData.address)
      handleFormatLang(codeFromStorage)
      // console.log('当前语言', lang)
      handleLoadTradingView()
    }
    // poolData
  }, [codeFromStorage, poolData.address, lang]) // 注意，这里的空数组[]确保useEffect只在组件挂载时运行一次

  function handleFormatLang(val) {
    // console.log(val, '语言调整')
    let lang = val
    if (lang === 'zh-TW') {
      lang = 'zh_TW'
    }
    if (lang === 'en-US') {
      lang = 'en'
    }
    if (lang === 'zh-CN') {
      lang = 'zh_TW'
    }
    if (lang === 'ko-KR') {
      lang = 'en'
    }
    // return lang;
    setLang(lang)
  }

  // 修改设定的订阅时间
  function handleLoadTradingView(val?: string) {
    // console.log('方法已执行', val)
    let theme_str = 'white'
    const tvid = document.getElementById('tv_chart_container')
    // console.log('容器', tvid)
    let params = {
      // interval: val || interval, // 分辨率（时间周期）
      // interval: 'day',
      interval: interval,
      wgconfig: handleGetThemeConfig(theme_str),
      // self: this,
      container: tvid,
    }
    // console.log(params, '修改设定的订阅时间')
    if (forwhat === 'kline') {
      params = Object.assign(params, {
        // name: '0x2a3b2d64960036de519dc4a45cafd532bfa99ff0', // k线显示的交易对
        // ticker: '0x2a3b2d64960036de519dc4a45cafd532bfa99ff0', // 后台请求币种对
        name: poolData?.token0?.address,
        ticker: poolData?.token0?.address,
        pricescale: 10 ** 18, // 保留小数位位数
        pairId: poolData?.address,
      })
      Tv.init(params, () => {
        // console.log('初始化成功')
        handleChartReady()
      })
    }
  }

  // 获取主题
  function handleGetThemeConfig(str) {
    const themeobj = {
      black: {
        locale: lang, // 多语言
        custom_css_url: '/static/theme/black.css',
        toolbar_bg: '#152247', // 工具栏背景色
        // 加载背景色, 加载条颜色
        loading_screen: { backgroundColor: '#152247', foregroundColor: '#fff' },
        overrides: {
          'paneProperties.background': '#152247', // 背景色
          'paneProperties.vertGridProperties.color': 'RGBA(153, 153, 156, 0.1)', //横线
          'paneProperties.horzGridProperties.color': 'RGBA(153, 153, 156, 0.1)', //竖线
          'scalesProperties.textColor': '#AAA', // 字体颜色
        },
      },
      white: {
        locale: lang, // 多语言
        custom_css_url: '/static/theme/white.css',
        toolbar_bg: '#fff', // 工具栏背景色
        // 加载背景色, 加载条颜色
        // loading_screen: { backgroundColor: '#fff', foregroundColor: 'RGBA(0, 148, 213, 1)' },
        overrides: {
          'paneProperties.background': '#ffffff',
          'paneProperties.vertGridProperties.color': 'RGBA(153, 153, 156, 0.18)',
          'paneProperties.horzGridProperties.color': 'RGBA(153, 153, 156, 0.18)',
          'scalesProperties.textColor': '#333',
        },
      },
    }
    const overrides = {
      // "mainSeriesProperties.candleStyle.upColor": "#14A670", // 涨、蜡烛图的颜色
      // "mainSeriesProperties.candleStyle.downColor": "#F83F3F", // 跌、蜡烛图的颜色
      'mainSeriesProperties.candleStyle.drawBorder': true, // 是否显示蜡烛图的边框
      'mainSeriesProperties.candleStyle.borderUpColor': '#40A771', // 蜡烛图的边框颜色
      'mainSeriesProperties.candleStyle.borderDownColor': '#E53A48',
      'mainSeriesProperties.candleStyle.wickUpColor': '#40A771', // 蜡烛图中间线的颜色
      'mainSeriesProperties.candleStyle.wickDownColor': '#E53A48',
      volumePaneSize: 'medium', // 成交量显示大小 支持的值: large, medium, small, tiny
      'timeScale.rightOffset': 2, // 蜡烛图最右边的那条与Y轴的距离
      toggleButton: {
        background: '#FF0000', // 设置 toggleButton 的背景颜色为红色
        text: '#FFFFFF', // 设置 toggleButton 的文字颜色为白色
      },
      // "paneProperties.legendProperties.showLegend": false, // 是否显示 交易对和分辨率（时间周期）
      // "paneProperties.legendProperties.showSeriesTitle": true, // // 是否显示 交易对和分辨率（时间周期）
      'paneProperties.legendProperties.showStudyArguments': false, // 是否显示成交量右上角Volume -> (20)
      'paneProperties.legendProperties.showStudyTitles': true, // 是否显示成交量右上角Volume
      'paneProperties.legendProperties.showStudyValues': true, // 是否显示成交量 数字
      'mainSeriesProperties.lineStyle.color': '#6ba583', // 折线图的颜色
      'scalesProperties.fontSize': 11, // 右侧刻度值字体大小
      'paneProperties.horzGridProperties.style': 1, // 水平线虚线
      'paneProperties.vertGridProperties.style': 1, // 垂直线虚线
      // 'paneProperties.legendProperties.showBarChange': !0
    }
    themeobj.white.overrides = Object.assign(themeobj.white.overrides, overrides)
    themeobj.black.overrides = Object.assign(themeobj.black.overrides, overrides)
    return themeobj[str]
  }

  // 准备初始化图表
  function handleChartReady() {
    if (setValue) setValue(undefined)
    if (setLabel) setLabel(undefined)
    // const _this = this;
    Tv.tvWidget.onChartReady(() => {
      Tv.tvWidget.headerReady().then(() => {
        // Tv.createdDataBtn(this.$t('tv.minute'), this.interval === '1', '1');
        Tv.createdDataBtn(t('noah480'), interval === '5', '5')
        Tv.createdDataBtn(t('noah215'), interval === '15', '15')
        // Tv.createdDataBtn(t('noah214'), interval === '30', '30');
        Tv.createdDataBtn(t('noah214'), interval === '60', '60')
        Tv.createdDataBtn(t('noah197'), interval === '240', '240')
        Tv.createdDataBtn(t('noah198'), interval === '1D', '1D')
        Tv.createdDataBtn(t('noah199'), interval === '1W', '1W')
        Tv.createdDataBtn(t('noah200'), interval === '1M', '1M')

        Tv.createdFillWinBtn()
      })

      // Tv.tvWidget.activeChart().crossHairMoved().subscribe(null,({ time, price }) => {
      //   console.log(time, price)
      //   const timestamp = time as number
      //   const now = new Date(timestamp)
      //   const times = `${now.toLocaleString(lang, {
      //     year: 'numeric',
      //     month: 'short',
      //     day: 'numeric',
      //     // hour: 'numeric',
      //     // minute: '2-digit',
      //     timeZone: 'UTC',
      //   })}`
      //   if (setValue) setValue(formatNumber(formatPrice(price), price))
      //   if (setLabel) setLabel(times)
      // });
    })
    // this.loading = false;
  }

  // 取消订阅
  function handleTradViewUnsubscribe() {
    let type = 'minute'
    const resolution = interval.toString()
    if (resolution === '5') {
      type = 'minute5'
    } else if (resolution === '15') {
      type = 'minute15'
    } else if (resolution === '30') {
      type = 'minute30'
    } else if (resolution === '60') {
      type = 'hour'
    } else if (resolution === '240') {
      type = 'hour4'
    } else if (resolution === '1D') {
      type = 'day'
    } else if (resolution === '1W') {
      type = 'week'
    } else if (resolution === '1M') {
      type = 'month'
    }
    if (poolData?.address && forwhat === 'kline') {
      const env = process.env.NODE_ENV
      let uri = 'wss://api.noahark.io/aws'

      let BASE_URL = 'api.noahark.io'
      if (process.env.NODE_ENV !== 'development') {
        BASE_URL = typeof window !== 'undefined' ? window.location.hostname : ''
      }

      uri = `wss://` + BASE_URL + `/aws`

      if (process.env.NODE_ENV === 'development') {
        uri = 'ws://192.168.50.2:10078'
      }
      console.log('wss-URL', uri)

      const client = new CFClient({ env, uri, debug: false })
      Io.cfwsUnsubscribe(client)
      // Io.cfwsUnsubscribe(`kline.${type}.${poolData?.address}`)
      // Io.cfwsUnsubscribe()
      return
    }
  }

  useEffect(() => {
    return () => {
      // console.log('我离开了~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
      handleTradViewUnsubscribe()
    }
  }, [])

  return (
    <div style={{ height: isMobile ? '370px' : '500px', position: 'relative', paddingBottom: '20px' }}>
      <div style={{ height: '100%' }} id="tv_chart_container" className="TVChartContainer" ref={chartContainerRef} />
    </div>
  )
}

export default TVChartContainerComponent
